<!-- TODO Visszatenni, ha kell a publikus mező szerkesztés -->

<!--mat-checkbox
  class="easy-checkbox ms-auto"
  (change)="showVisibleFields = $event.checked"
  [checked]="showVisibleFields"
>
  {{ "SHARED.VISIBLE_FIELDS.TOGGLE" | translate }}
</mat-checkbox-->

<form
  class="easy-form"
  [formGroup]="form"
  appScrollToInvalidControl
  [appEditableWithRole]="['MERCHANT_ADMIN', 'TELESALES']"
>
  <ng-template let-name #boolField>
    <app-visible-fields-checkbox
      *ngIf="showVisibleFields"
      [fieldName]="name"
    ></app-visible-fields-checkbox>
    <mat-form-field>
      <app-easy-checkbox
        [formControlName]="name"
        [label]="TITLE + name | translate"
      ></app-easy-checkbox>
    </mat-form-field>
  </ng-template>

  <ng-template let-name #textField>
    <app-visible-fields-checkbox
      class="margin-top"
      *ngIf="showVisibleFields"
      [fieldName]="name"
    ></app-visible-fields-checkbox>

    <mat-form-field class="w-100">
      <app-easy-input
        [label]="TITLE + name | translate"
        [formControlName]="name"
        [placeholder]="PLACEHOLDER + name | translate"
        [hideRequiredLabel]="false"
      ></app-easy-input>
    </mat-form-field>
    <!-- TODO -->
    <!-- <mat-form-field appearance="outline">
          <mat-label>{{ TITLE + name | translate }}</mat-label>
          <input
            matInput
            [placeholder]="PLACEHOLDER + name | translate"
            [formControlName]="name"
          />
          <mat-hint *ngIf="get(name).hasError('pattern')">
            {{ HINT + name | translate }}. &nbsp;
          </mat-hint>
          <mat-hint *ngIf="get(name).hasError(name)">
            {{ HINT + name | translate }}. &nbsp;
          </mat-hint>
          <mat-hint>{{ REQUIRED | translate }}</mat-hint>
          <mat-error *ngIf="getServerError(name)">
            {{ getServerError(name) }}
          </mat-error>
        </mat-form-field> -->
  </ng-template>

  <fieldset
    class="in-two-columns w-100"
    [class.with-visible-fields]="showVisibleFields"
  >
    <legend>{{ TITLE + "MERCHANT" | translate }}:</legend>

    <app-image-picker-legacy
      [title]="TITLE + 'LOGO' | translate"
      [placeholderUrl]="logoUrl"
      [isLoading]="isLogoUpdating"
      (fileSelectedEvent)="onLogoSelected($event)"
    ></app-image-picker-legacy>

    <ng-container
      *ngTemplateOutlet="textField; context: { $implicit: 'companyName' }"
    ></ng-container>

    <ng-container
      *ngTemplateOutlet="textField; context: { $implicit: 'brandName' }"
    ></ng-container>

    <ng-container
      *ngTemplateOutlet="textField; context: { $implicit: 'taxNumber' }"
    ></ng-container>
  </fieldset>
  <fieldset
    class="in-two-columns w-100"
    [class.with-visible-fields]="showVisibleFields"
  >
    <legend>{{ TITLE + "CONTACTS" | translate }}:</legend>
    <ng-container
      *ngTemplateOutlet="textField; context: { $implicit: 'email' }"
    ></ng-container>
    <app-visible-fields-checkbox
      class="margin-top"
      *ngIf="showVisibleFields"
      fieldName="phone"
    ></app-visible-fields-checkbox>
    <mat-form-field>
      <app-easy-phone-subform
        class="w-100"
        formControlName="phone"
        [label]="TITLE + 'phone'"
        [placeholder]="PLACEHOLDER + 'phone'"
        [hint]="HINT + 'phone'"
      ></app-easy-phone-subform>
    </mat-form-field>
  </fieldset>

  <!-- businessAddress -->

  <fieldset
    class="in-one-column w-100"
    [class.with-visible-fields]="showVisibleFields"
  >
    <app-visible-fields-checkbox
      class="margin-top-minus"
      *ngIf="showVisibleFields"
      fieldName="businessAddress"
    ></app-visible-fields-checkbox>

    <legend>{{ TITLE + "ADDRESS" | translate }}:</legend>

    <app-easy-address-subform
      class="w-100"
      title="{{ TITLE + 'ADDRESS' }}"
      groupName="businessAddress"
    >
    </app-easy-address-subform>
  </fieldset>

  <fieldset
    class="in-one-column w-100"
    [class.with-visible-fields]="showVisibleFields"
  >
    <legend>{{ TITLE + "OTHER" | translate }}:</legend>

    <ng-container
      *ngTemplateOutlet="boolField; context: { $implicit: 'vatExempt' }"
    ></ng-container>

    <ng-container
      *ngTemplateOutlet="boolField; context: { $implicit: 'gs1Partner' }"
    ></ng-container>

    <!-- packing material -->

    <app-visible-fields-checkbox
      class="margin-top"
      *ngIf="showVisibleFields"
      fieldName="packingMaterial"
    ></app-visible-fields-checkbox>

    <mat-form-field class="w-100">
      <app-easy-select
        [label]="'MERCHANT.TITLE.PACKING_MATERIAL' | translate"
        formControlName="packingMaterial"
        [options]="
          packingMaterialRegistrations
            | toSelectOption: 'MERCHANT.PACKING_MATERIAL.'
        "
        [labelAttribute]="'name'"
        [valueAttribute]="'value'"
        [translatePrefixForSelected]="'MERCHANT.PACKING_MATERIAL.'"
        [differentLabelWhenSelected]="true"
        [hasEmptyOption]="false"
      >
      </app-easy-select>
    </mat-form-field>
  </fieldset>

  <div class="button-row">
    <ng-container *ngIf="!firstLogin; else nextButton">
      <button
        type="button"
        color="primary"
        mat-stroked-button
        (click)="onCancel()"
      >
        {{ "MERCHANT.BTN.CANCEL" | translate | uppercase }}
      </button>
      <button mat-raised-button color="primary" (click)="onSubmit()">
        {{ "MERCHANT.BTN.UPDATE" | translate | uppercase }}
      </button>
    </ng-container>
    <ng-template #nextButton>
      <button
        mat-raised-button
        class="ms-auto"
        color="primary"
        (click)="onSubmit()"
      >
        {{ "MERCHANT.BTN.NEXT" | translate | uppercase }}
      </button>
    </ng-template>
  </div>
</form>
